package io.github.kingsword09.symbolcraft.symbols.icons.materialsymbols.icons

import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.PathFillType.Companion.NonZero
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.graphics.StrokeCap.Companion.Butt
import androidx.compose.ui.graphics.StrokeJoin.Companion.Miter
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.graphics.vector.ImageVector.Builder
import androidx.compose.ui.graphics.vector.path
import androidx.compose.ui.unit.dp
import io.github.kingsword09.symbolcraft.symbols.icons.materialsymbols.Icons

public val Icons.SearchOffW500Rounded: ImageVector
    get() {
        if (_searchOffW500Rounded != null) {
            return _searchOffW500Rounded!!
        }
        _searchOffW500Rounded = Builder(name = "SearchOffW500Rounded", defaultWidth = 24.0.dp, defaultHeight = 24.0.dp, viewportWidth = 960.0f, viewportHeight = 960.0f).apply {
            path(fill = SolidColor(Color(0xFF000000)), stroke = null, strokeLineWidth = 0.0f, strokeLineCap = Butt, strokeLineJoin = Miter, strokeLineMiter = 4.0f, pathFillType = NonZero) {
                moveToRelative(279.76f, 713.26f)
                lineToRelative(53.37f, 54.13f)
                quadToRelative(7.2f, 7.2f, 16.63f, 7.2f)
                quadToRelative(9.44f, 0.0f, 16.63f, -7.2f)
                quadToRelative(7.2f, -7.19f, 7.2f, -17.01f)
                quadToRelative(0.0f, -9.81f, -7.2f, -17.01f)
                lineToRelative(-53.13f, -53.13f)
                lineToRelative(54.37f, -54.37f)
                quadToRelative(7.2f, -7.2f, 7.2f, -16.63f)
                quadToRelative(0.0f, -9.44f, -7.2f, -16.63f)
                quadToRelative(-7.2f, -7.2f, -16.63f, -7.2f)
                reflectiveQuadToRelative(-16.63f, 7.2f)
                lineToRelative(-54.13f, 54.13f)
                lineToRelative(-54.37f, -54.37f)
                quadToRelative(-7.2f, -7.2f, -16.63f, -7.2f)
                quadToRelative(-9.44f, 0.0f, -16.63f, 7.2f)
                quadToRelative(-7.2f, 7.2f, -7.2f, 16.63f)
                reflectiveQuadToRelative(7.2f, 16.63f)
                lineToRelative(54.13f, 54.13f)
                lineToRelative(-54.37f, 54.37f)
                quadToRelative(-7.2f, 7.2f, -7.2f, 16.63f)
                quadToRelative(0.0f, 9.44f, 7.2f, 16.63f)
                quadToRelative(7.2f, 7.2f, 16.63f, 7.2f)
                reflectiveQuadToRelative(16.63f, -7.2f)
                lineToRelative(54.13f, -54.13f)
                close()
                moveTo(138.5f, 821.5f)
                quadTo(80.0f, 763.0f, 80.0f, 680.0f)
                reflectiveQuadToRelative(58.5f, -141.5f)
                quadTo(197.0f, 480.0f, 280.0f, 480.0f)
                reflectiveQuadToRelative(141.5f, 58.5f)
                quadTo(480.0f, 597.0f, 480.0f, 680.0f)
                reflectiveQuadToRelative(-58.5f, 141.5f)
                quadTo(363.0f, 880.0f, 280.0f, 880.0f)
                reflectiveQuadToRelative(-141.5f, -58.5f)
                close()
                moveTo(568.48f, 592.13f)
                quadToRelative(-0.72f, 0.48f, -1.56f, 0.96f)
                quadToRelative(-0.83f, 0.48f, -1.79f, 0.71f)
                quadToRelative(-11.04f, -18.5f, -24.54f, -35.22f)
                quadToRelative(-13.5f, -16.73f, -27.46f, -31.12f)
                quadToRelative(37.04f, -23.29f, 59.21f, -62.09f)
                quadToRelative(22.16f, -38.8f, 22.16f, -85.37f)
                quadToRelative(0.0f, -72.85f, -50.83f, -123.67f)
                quadTo(492.85f, 205.5f, 420.0f, 205.5f)
                reflectiveQuadToRelative(-123.67f, 50.83f)
                quadTo(245.5f, 307.15f, 245.5f, 380.0f)
                quadToRelative(0.0f, 6.0f, 0.38f, 11.38f)
                quadToRelative(0.38f, 5.38f, 1.38f, 11.14f)
                quadToRelative(-20.63f, 2.0f, -45.0f, 8.6f)
                reflectiveQuadToRelative(-43.28f, 16.51f)
                quadToRelative(-2.24f, -11.72f, -3.36f, -23.67f)
                quadTo(154.5f, 392.0f, 154.5f, 380.0f)
                quadToRelative(0.0f, -111.15f, 77.17f, -188.33f)
                quadTo(308.85f, 114.5f, 420.0f, 114.5f)
                reflectiveQuadToRelative(188.33f, 77.17f)
                quadTo(685.5f, 268.85f, 685.5f, 380.0f)
                quadToRelative(0.0f, 43.0f, -13.14f, 81.5f)
                reflectiveQuadToRelative(-36.19f, 69.78f)
                lineToRelative(221.09f, 222.33f)
                quadToRelative(12.67f, 12.67f, 13.06f, 31.44f)
                quadToRelative(0.38f, 18.78f, -13.06f, 32.21f)
                quadToRelative(-12.67f, 12.67f, -31.83f, 12.67f)
                quadToRelative(-19.15f, 0.0f, -31.82f, -12.67f)
                lineTo(568.48f, 592.13f)
                close()
            }
        }
        .build()
        return _searchOffW500Rounded!!
    }

private var _searchOffW500Rounded: ImageVector? = null
